var map = {
	"./40251.png": 12,
	"./AudiS5.png": 48,
	"./Bugatti.png": 49,
	"./FordMustang.png": 50,
	"./Kia.jpg": 51,
	"./LOGOAuto.svg": 22,
	"./Lexus.jpg": 52,
	"./MercedesGle.jpg": 53,
	"./Nexia.jpg": 54,
	"./Opel.jpg": 55,
	"./Porsh.png": 56,
	"./Rectangle1.png": 23,
	"./Rectangle2.png": 24,
	"./Rectangle3.png": 25,
	"./Rectangle44.png": 26,
	"./Rectangle7.png": 16,
	"./Vector.png": 15,
	"./Vector11.svg": 9,
	"./basket3081797.svg": 14,
	"./ford.jpg": 57,
	"./movie-ticket1.svg": 27,
	"./nissan.jpg": 58,
	"./online-payment11.svg": 28,
	"./revievs2.jpg": 17,
	"./revievs3.jpg": 18,
	"./search80737.svg": 13,
	"./tickets3.svg": 59,
	"./touchscreen1.svg": 29,
	"./vaz.jpg": 60,
	"./winner1.svg": 30
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;